// Das eigene Tageslimit mit der Reserve aus den Einstellungen
// (Einstellungen › „Claude · Reserve am Samstag", s.claude_reserve). Die
// Rechnung selbst steht in claude.ts (tageslimit), ohne Store testbar.
import { getSystemWerte, startSystemWerte } from "../einstellungen/system.svelte";
import { tageslimit, type Tageslimit, type Verbrauch } from "./claude";

/** Ohne gespeicherten Wert gilt 20 % (Tim 01.11.2026; Vorgabe im Backend,
 *  settings.ClaudeReserveDefault). */
export const RESERVE_STANDARD = 20;

/** Die Reserve als Anteil (0,2); undefined, bis die Einstellungen geladen
 *  sind -- sonst stünde kurz ein Limit mit der Vorgabe da und spränge. */
export function reserveAnteil(): number | undefined {
  startSystemWerte();
  const p = getSystemWerte()?.claude_reserve_prozent;
  return p == null ? undefined : p / 100;
}

export function tageslimitJetzt(v: Verbrauch | undefined, jetzt: Date): Tageslimit | undefined {
  const r = reserveAnteil();
  return r == null ? undefined : tageslimit(v, r, jetzt);
}
